import Api from '../../shared/Api';
import { Promise } from 'es6-promise';
import { ISearchResult } from './Entities';

class SearchApi {
    static search(search: string, signal?: AbortSignal): Promise<ISearchResult> {
        let searchTerm = encodeURIComponent(search);
        return new Api().get(`/views/search?search=${searchTerm}`, {}, undefined, signal);
    }
}

export default SearchApi;
